import React from "react";
import { useDispatch } from "react-redux";
import { updateMeetingLink, createMeetingLink } from "../../store/actions/meeting.action";
import { toast } from "react-toastify";

export default function PublicInfoSectionFUHSD({
  t,
  ChangeImage,
  openIsChange,
  closeIsChange,
  sendData,
  isChange,
  parsedUserProfile,
  firstLanguage,
  setFirstLanguage,
  languages,
  firstLanguageSkillLevel,
  setFirstLanguageSkillLevel,
  alsoSpeak,
  setAlsoSpeak,
  cityCountry,
  setCityCountry,
  targetGraduationYearHighSchool,
  setTargetGraduationYearHighSchool,
  transform_languages,
  transform_skillLevel,
  onSaveMeetingLink,
}) {
  const dispatch = useDispatch();
  const [isEditingMeetingLink, setIsEditingMeetingLink] = React.useState(false);
  const [tempMeetingLink, setTempMeetingLink] = React.useState("");

  const handleEditMeetingLink = () => {
    setTempMeetingLink(parsedUserProfile?.meeting_link || "");
    setIsEditingMeetingLink(true);
  };

  const handleSaveMeetingLink = async () => {
    try {
      const token = localStorage.getItem("token");
      const meetingLinkId = parsedUserProfile?.meeting_link_id;
      
      if (!token) {
        toast.error("Authentication required", { position: "bottom-right" });
        return;
      }
      
      // Validate that the meeting link starts with the required FUHSD Zoom URL
      if (!tempMeetingLink.startsWith("https://fuhsd-org.zoom.us/")) {
        toast.error("Please use your Zoom account associated with your FUHSD school email. The meeting link must start with https://fuhsd-org.zoom.us/", { 
          position: "bottom-right",
          autoClose: 5000
        });
        return;
      }

      if (!meetingLinkId) {
        // Create a new meeting link if ID not found
        await dispatch(createMeetingLink({
          token,
          link: tempMeetingLink,
          meeting_link_provider: "ZOOM",
          leader: parsedUserProfile?.id
        }));
      } else {
        // Update existing meeting link
        await dispatch(updateMeetingLink({
          token,
          id: meetingLinkId,
          link: tempMeetingLink
        }));
      }
      
      setIsEditingMeetingLink(false);
      
      // Call parent's callback if provided
      if (onSaveMeetingLink) {
        onSaveMeetingLink(tempMeetingLink);
      }
    } catch (error) {
      console.error("Error updating meeting link:", error);
    }
  };

  const handleCancelMeetingLink = () => {
    setIsEditingMeetingLink(false);
    setTempMeetingLink("");
  };

  return (
    <div id="section1" className="w-full flex flex-col p-2 md:pb-12 pb-2">
      <div className="relative w-full text-center">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <span className="relative bg-[var(--bg)] px-3 text-lg font-bold text-[var(--brand)] uppercase tracking-wider">
          {t("user_home.public_info")} - FUHSD
        </span>
      </div>

      <button className="flex justify-end">
        <img
          src={ChangeImage}
          alt="changeProfile"
          className="md:w-[40px] md:h-[40px]"
          onClick={openIsChange}
        />
      </button>

      <div className="flex gap-5 md:gap-10 flex-col md:flex-row">
        {/* Left side of the section of MY PUBLIC INFO */}
        <div className="w-full md:w-1/2 flex flex-col gap-4">
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.1st_lang")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {t(transform_languages(parsedUserProfile?.first_language))}
              </p>
            ) : (
              <select
                type="select"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={firstLanguage || ""}
                onChange={(e) => setFirstLanguage(e.target.value)}
              >
                <option value="">{t("user_home.select")}</option>
                {languages.map((language) => (
                  <option key={language.value} value={language.value}>
                    {t(language.label)}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.1st_lang_skill")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {t(
                  transform_skillLevel(
                    parsedUserProfile?.first_language_skill_level
                  )
                )}
              </p>
            ) : (
              <select
                type="select"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={firstLanguageSkillLevel || ""}
                onChange={(e) => setFirstLanguageSkillLevel(e.target.value)}
              >
                <option value={""}>{t("user_home.select")}</option>
                <option value={"1"}>{t("generic.skill_1")}</option>
                <option value={"2"}>{t("generic.skill_2")}</option>
                <option value={"3"}>{t("generic.skill_3")}</option>
                <option value={"4"}>{t("generic.skill_4")}</option>
                <option value={"5"}>{t("generic.skill_5")}</option>
              </select>
            )}
          </div>
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.also_speak")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {parsedUserProfile?.also_speak}
              </p>
            ) : (
              <input
                type="text"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={alsoSpeak || ""}
                onChange={(e) => setAlsoSpeak(e.target.value)}
              />
            )}
          </div>
        </div>

        {/* Right side of the section of MY PUBLIC INFO */}
        <div className="w-full md:w-1/2 flex flex-col gap-4">
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.city_country")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {parsedUserProfile?.city_country}
              </p>
            ) : (
              <input
                type="text"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={cityCountry || ""}
                onChange={(e) => setCityCountry(e.target.value)}
              />
            )}
          </div>
          <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
            <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
              {t("user_home.target_graduation_year")}:
            </p>
            {isChange === false ? (
              <p className="text-base md:text-lg font-normal text-black">
                {parsedUserProfile?.target_graduation_year_high_school}
              </p>
            ) : (
              <select
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base w-full md:w-auto"
                value={targetGraduationYearHighSchool || ""}
                onChange={(e) => setTargetGraduationYearHighSchool(e.target.value)}
              >
                <option value="">{t("user_home.select")}</option>
                {Array.from({ length: 15 }, (_, i) => new Date().getFullYear() + i).map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
      </div>

      {/* Meeting Link Section - Below entire public info */}
      <div className="w-full mt-6 flex flex-col gap-2">
        <div className="flex items-start md:items-center flex-col md:flex-row gap-2">
          <p className="text-base md:text-lg font-medium text-[var(--brand)] md:min-w-[200px]">
            {t("user_home.meeting_link")}:
          </p>
          {!isEditingMeetingLink ? (
            <div className="flex items-center gap-2 flex-1 w-full">
              <p className="text-base md:text-lg font-normal text-black break-all flex-1">
                {parsedUserProfile?.meeting_link || "N/A"}
              </p>
              <button className="flex-shrink-0">
                <img
                  src={ChangeImage}
                  alt="editMeetingLink"
                  className="md:w-[40px] md:h-[40px] w-[30px] h-[30px]"
                  onClick={handleEditMeetingLink}
                />
              </button>
            </div>
          ) : (
            <div className="flex-1 flex flex-col md:flex-row gap-2 items-start md:items-center">
              <input
                type="text"
                className="border border-[var(--brand)] px-2 py-1 bg-[var(--bg)] text-base flex-1 w-full"
                value={tempMeetingLink}
                onChange={(e) => setTempMeetingLink(e.target.value)}
                placeholder="Enter meeting link"
              />
              <div className="flex gap-2">
                <button
                  className="bg-[var(--brand)] rounded-[5px] px-4 py-1 text-white text-sm"
                  onClick={handleSaveMeetingLink}
                >
                  {t("generic.save") || "Save"}
                </button>
                <button
                  className="bg-gray-500 rounded-[5px] px-4 py-1 text-white text-sm"
                  onClick={handleCancelMeetingLink}
                >
                  {t("generic.cancel") || "Cancel"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {isChange && (
        <div className="flex justify-end gap-4">
          <button
            className="bg-[var(--brand)] rounded-[5px] w-[70px] h-[30px] xl:w-[100px] xl:h-[40px] text-white"
            onClick={closeIsChange}
          >
            {t("generic.cancel")}
          </button>
          <button
            className="bg-[var(--brand)] rounded-[5px] w-[70px] h-[30px] xl:w-[100px] xl:h-[40px] text-white"
            onClick={sendData}
          >
            {t("generic.save")}
          </button>
        </div>
      )}
    </div>
  );
}
